import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../design-system/tokens/colors';
import { PaperAirplaneIcon } from '@heroicons/react/outline';
import type { OutreachCellData } from '../types';

interface OutreachCellProps {
  data?: OutreachCellData;
  onPreview: () => void;
}

const StatusBadge = styled.div<{ $sent: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  user-select: none;
  
  ${props => props.$sent ? `
    background: rgba(16, 185, 129, 0.08);
    color: #059669;
  ` : `
    background: rgba(0, 0, 0, 0.03);
    color: ${colors.text.secondary};
  `}
`;

const IconButton = styled.button<{ $visible: boolean }>`
  display: ${props => props.$visible ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.12s ease;
  flex-shrink: 0;
  margin-left: auto;
  
  &:hover {
    background: rgba(0, 0, 0, 0.04);
    color: #6b7280;
  }
  
  &:active {
    background: rgba(0, 0, 0, 0.08);
  }
  
  svg {
    width: 13px;
    height: 13px;
    transform: rotate(90deg);
  }
`;

const CellContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 4px 0;
`;

export const OutreachCell: React.FC<OutreachCellProps> = ({
  data,
  onPreview
}) => {
  const status = data?.status || 'draft';
  const isSent = status === 'sent' || status === 'opened' || status === 'replied';

  return (
    <CellContainer>
      {/* Status Badge - Read-only display */}
      <StatusBadge $sent={isSent}>
        <span>{isSent ? 'Sent' : 'Not sent'}</span>
      </StatusBadge>
      
      {/* Send Icon - Always visible if not sent */}
      <IconButton 
        $visible={!isSent}
        onClick={onPreview} 
        title="Preview & send email"
      >
        <PaperAirplaneIcon />
      </IconButton>
    </CellContainer>
  );
};

